import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { Separator } from '@change/ds-core-ui/Separator';

import { JoinTheCommunity } from './components/JoinTheCommunity';
import { useJoinTheCommunity } from './components/JoinTheCommunity/hooks/useJoinTheCommunity';
// EXPERIMENT: psf_featured_spiking_petition_experiment — remove with experiment cleanup
import { useFeaturedSpikingPetitionExperiment } from './hooks/useFeaturedSpikingPetitionExperiment';
import { useFeaturedSpikingPetitionShareRedirect } from './hooks/useFeaturedSpikingPetitionShareRedirect';
import { useFeaturedSpikingPetitionSkip } from './hooks/useFeaturedSpikingPetitionSkip';
import { usePageFooter } from './hooks/usePageFooter';

export const PageFooter: React.FC<EmptyProps> = () => {
	const {
		data: { skipLabel, skipUrl },
		actions: { handleSkipClick },
	} = usePageFooter();

	const {
		data: { displayed: joinTheCommunityDisplayed },
	} = useJoinTheCommunity();

	// EXPERIMENT: psf_featured_spiking_petition_experiment — remove with experiment cleanup
	// Treats the experiment on mount (every arm). Called once here, so the arm is the same for both triggers.
	const {
		data: { arm: featuredSpikingPetitionArm },
	} = useFeaturedSpikingPetitionExperiment();
	const {
		data: { skipHref },
		actions: { handleFeaturedSkipClick },
	} = useFeaturedSpikingPetitionSkip(skipUrl, featuredSpikingPetitionArm);
	useFeaturedSpikingPetitionShareRedirect(featuredSpikingPetitionArm);

	return (
		<div className="flex flex-col gap-7 px-4 py-7 text-center md:mt-5">
			<JoinTheCommunity />

			{joinTheCommunityDisplayed && <Separator className="m-0" />}

			<Button
				as="a"
				// EXPERIMENT: psf_featured_spiking_petition_experiment — back to `skipUrl` with experiment cleanup
				href={skipHref}
				// EXPERIMENT: psf_featured_spiking_petition_experiment — back to `handleSkipClick` with experiment cleanup
				onClick={() => {
					handleSkipClick();
					handleFeaturedSkipClick();
				}}
				data-qa="skip-link"
				variant="tertiary"
				size="large"
				className="self-center"
			>
				{skipLabel}
			</Button>
		</div>
	);
};
